import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useState } from "preact/hooks"
import { sortOptions } from "../../config"
import FacetAccordion from "./FacetAccordion"

export default function MobileSortBlock({ className }) {
    const { activeSort, setSort } = useSort(sortOptions)
    const [active, setActive] = useState(false);

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const handleToggleAccordion = () => {
        setActive(prevState => !prevState)
    }

    return (
        <FacetAccordion
            className="ns-only-mobile"
            name='sort by'
            id='sort_by'
            active={active}
            onClick={handleToggleAccordion}>
            <div id="Mobile-SortBy-Options" class="mobile-facets__sort-options-container">
                <div class="mobile-facets__sort-options">
                    {options.map(option => (
                        <div class={`ss__list__option radio ${activeSort === option.value ? 'ss__active' : ''}`}>
                            <input 
                                type="radio" 
                                class="ss__sort__input" 
                                id={`SortBy-Option-${option.value}`} 
                                name="sort_by" 
                                value={option.value} 
                                onChange={handleSortChange}
                                />
                            <label for={`SortBy-Option-${option.value}`} class="font-primary subtitle-sm">{option.label}</label>
                        </div>
                    ))}
                </div>
            </div>
        </FacetAccordion>
    )
}